"use client";

import React from "react";
import type { TableContextType } from "./types";

const TableContext = React.createContext<TableContextType>({
  headers: [],
  rows: [],
  isResponsive: false,
});

export default TableContext;
